import React from 'react';
import { arrayOf, bool, number, shape, string } from 'prop-types';
import {
  menuItemsInsurance,
  menuItemsMerchant,
  menuItemsOperator,
  menuItemsAdminInsurance,
} from './menus';
import NavItem from './NavItem';
import { PartyTypes } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';
import InfoModal from './InfoModal';

const Sidebar = ({ location, menuOpen, partyTypes, user }) => {
  const [visibleInfoModal, _setVisibleInfoModal] = React.useState(false);

  const partyType = React.useMemo(
    () =>
      !partyTypes || !user
        ? null
        : LookupsHelper.getDescription(partyTypes, user.PartyType),
    [partyTypes, user]
  );

  const menuItems = React.useMemo(
    () =>
      partyType === PartyTypes.Merchant
        ? menuItemsMerchant
        : partyType === PartyTypes.Insurance
        ? menuItemsInsurance
        : partyType === PartyTypes.Admin_Insurance
        ? menuItemsAdminInsurance
        : partyType === PartyTypes.Operator
        ? menuItemsOperator
        : [],
    [partyType]
  );

  const activeTopLevelKey = React.useMemo(() => {
    if (!location) return null;
    let pathname = location.pathname;
    if (pathname[0] === '/') pathname = pathname.substr(1);

    if (!pathname) return 'dashboard';

    const { key = null } =
      menuItems.find(
        mi =>
          pathname.indexOf(mi.key) >= 0 ||
          (mi.subItems || []).find(
            minner => pathname.indexOf(minner.key) >= 0
          ) != null
      ) || {};
    return key;
  }, [location, menuItems]);

  const [openTopLevelKey, _setOpenTopLevelKey] =
    React.useState(activeTopLevelKey);

  const setOpenTopLevelKey = React.useCallback(
    newKey => {
      _setOpenTopLevelKey(oldKey => (newKey === oldKey ? null : newKey));
    },
    [_setOpenTopLevelKey]
  );

  const openModal = modal => {
    if (modal === 'Info') _setVisibleInfoModal(true);
  };

  const closeModal = modal => {
    if (modal === 'Info') _setVisibleInfoModal(false);
  };

  return (
    <div className="page-sidebar-wrapper">
      <div className="page-sidebar-bg" />
      <div
        className={`page-sidebar navbar-collapse collapse ${
          menuOpen ? 'in' : ''
        }`}
      >
        <ul
          className="page-sidebar-menu  page-header-fixed "
          data-keep-expanded="false"
          data-auto-scroll="true"
          data-slide-speed="200"
          style={{ paddingTop: '20px' }}
        >
          <li className="sidebar-toggler-wrapper hidden">
            <div className="sidebar-toggler">
              <span />
            </div>
          </li>
          {menuItems.map(item => (
            <NavItem
              {...item}
              active={activeTopLevelKey === item.key}
              onToggle={() => setOpenTopLevelKey(item.key)}
              open={openTopLevelKey === item.key}
              openModal={openModal}
            >
              {item.subItems &&
                item.subItems.map(subItem => (
                  <NavItem
                    active={subItem.url === location.pathname}
                    {...subItem}
                  />
                ))}
            </NavItem>
          ))}
        </ul>
      </div>
      {visibleInfoModal ? (
        <InfoModal visible={visibleInfoModal} closeModal={closeModal} />
      ) : null}
    </div>
  );
};

Sidebar.propTypes = {
  location: shape({ pathname: string }),
  menuOpen: bool,
  partyTypes: arrayOf(shape({ id: string, description: string })),
  user: shape({ PartyType: number }),
};

export default Sidebar;
